/**
 * Short version of record to define is employee active
 */
export type CheckIsEmployeeActive = { active?: boolean; restricted?: boolean };

/**
 * Defines if current employee inactive to use re-activation flow
 * @param { CheckIsEmployeeActive } record
 * @returns { boolean }
 */
export const isEmployeeInactive = (record?: CheckIsEmployeeActive): boolean => {
    return !!(record && record.active === false && record.restricted === false);
};

/**
 * Drops to default employeeCenters and employeeDetails to use for re-activation
 * @param { any } record - Inactive employee data
 */
export const updateDataForReActivation = (record?: any): void => {
    if (!record) {
        return;
    }
    record.employeeCenters = [{}];
    record.employeeDetails = {
        ...record.employeeDetails,
        created: undefined,
        createdBy: '',
        updated: undefined,
        updatedBy: '',
        diplomas: [{ diplomaLink: '', diplomaSupplementLink: '' }],
        refresherCertificates: [],
        employmentHistoryLink: '',
        medicalHistoryLink: '',
        medicalCheckup: undefined,
        nameChangeDocumentLink: '',
        temporarilyDisplacedDocumentLink: '',
        attestationLetterLink: ''
    };
};
